import { render, staticRenderFns } from "./BetCancel.vue?vue&type=template&id=03d576e4&scoped=true&"
import script from "./BetCancel.vue?vue&type=script&lang=ts&"
export * from "./BetCancel.vue?vue&type=script&lang=ts&"
import style0 from "./BetCancel.vue?vue&type=style&index=0&id=03d576e4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d576e4",
  null
  
)

export default component.exports